import SvgIcon from '@mui/material/SvgIcon';

export const PagerDutyIcon = () => (
  <SvgIcon
    width="57"
    height="57"
    viewBox="0 0 57 57"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M56.25 0H0V56.25H56.25V0Z" fill="#04AC38" />
    <path d="M21.4688 37.125H15.8438V47.4375H21.4688V37.125Z" fill="white" />
    <path
      d="M37.1673 10.7025C34.139 9.0825 32.0184 8.8125 27.0525 8.8125H15.8438V32.25H27C31.4288 32.25 34.7381 31.98 37.6546 30.0356C40.8421 27.929 42.4856 24.42 42.4856 20.369C42.4809 15.9947 40.4589 12.4846 37.1673 10.7025ZM28.2499 27.2812H21.4689V13.7812L27.8701 13.7269C33.7041 13.6734 36.6198 15.7246 36.6198 20.371C36.6216 25.3913 33.0001 27.2812 28.2499 27.2812Z"
      fill="white"
    />
  </SvgIcon>
);
